import * as React from 'react';
import { useTheme } from '../../../../../theme';
import cn from 'classnames';
const List = ({ className, options, value, withSeparator, onChange }) => {
    const { List: theme } = useTheme('Shared');
    return (React.createElement("div", { className: cn(theme.root, className), role: "listbox" }, options.map((option, index) => (React.createElement(React.Fragment, { key: option.value },
        index !== 0 && withSeparator && React.createElement("div", { className: theme.separator }),
        React.createElement("div", { className: cn(theme.option, {
                [theme.selected]: option.value === (value === null || value === void 0 ? void 0 : value.value)
            }), onClick: () => onChange(option), role: "option", "aria-selected": option.value === (value === null || value === void 0 ? void 0 : value.value) },
            !!option.icon && React.createElement("div", { className: theme.icon }, option.icon),
            React.createElement("div", { className: theme.label }, option.label)))))));
};
export default List;
